import { defineCustomElement } from 'vue'
import AvailabilityCheckWidget from './AvailabilityCheckWidget.ce.vue'

const elementName = 'tkrz-verfuegbarkeitscheck'

if (!window.customElements.get(elementName)) {
  window.customElements.define(elementName, defineCustomElement(AvailabilityCheckWidget))
}
